<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <div class="pa-4">
        <label class="label-input">Section Name</label>
        <v-text-field v-model="fields.title" />

        <div class="mb-4">
          <div class="label-input">Settings</div>
          <div class="group-input">
            <v-row>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.settings.paddingTop"
                  label="Top Padding"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.settings.paddingBottom"
                  label="Bottom Padding"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="label-input-sub">Background color</div>
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields.settings.backgroundColor"
                  />
                  <v-text-field class="mb-0 mt-0" v-model="fields.settings.backgroundColor" hide-details />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="label-input-sub">Text color</div>
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields.settings.textColor"
                  />
                  <v-text-field class="mb-0 mt-0" v-model="fields.settings.textColor" hide-details />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Title Card</label>
          <ckeditor :editor="editor" v-model="fields.titleCard" :config="editorConfig" />
        </div>

        <div class="mb-4">
          <div class="label-input">Slider Settings</div>
          <div class="group-input">
            <v-row>
              <v-col cols="12" md="6">
                <div>
                  <label for="slidesPerView">Slides per view (desktop)</label>
                  <v-text-field
                    class="mb-0 mt-0"
                    type="number"
                    v-model.number="fields.slider.slidesPerView"
                    id="slidesPerView"
                    hide-details
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <v-checkbox
                    class=""
                    v-model="fields.slider.showPrice"
                    id="showPrice"
                    dense
                    hide-details
                    label="Show price"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div>
                  <v-checkbox
                    class="mb-1 mt-0"
                    v-model="fields.slider.showDiscountTag"
                    id="showDiscountTag"
                    dense
                    hide-details
                    label="Show discount tag"
                  />
                  <div v-if="fields.slider.showDiscountTag" class="group-item">
                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="d-flex align-center gap-3">
                          <input
                            style="width: 40px; height: 40px; margin-right: 12px"
                            type="color"
                            v-model="fields.slider.discountBg"
                          />
                          <v-text-field class="mb-0 mt-0" v-model="fields.slider.discountBg" hide-details />
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex align-center gap-3">
                          <input
                            style="width: 40px; height: 40px; margin-right: 12px"
                            type="color"
                            v-model="fields.slider.discountColor"
                          />
                          <v-text-field class="mb-0 mt-0" v-model="fields.slider.discountColor" hide-details />
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="label-input">Button</div>
          <div class="group-input">
            <v-row>
              <v-col cols="12" md="12">
                <div>
                  <v-checkbox class="mb-0 mt-0" v-model="fields.button.show" label="Show button" dense hide-details />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div>
                  <label for="buttonText">Button text</label>
                  <v-text-field class="mb-0 mt-0" v-model="fields.button.text" id="buttonText" hide-details />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <label for="buttonLink">Button link</label>
                  <v-text-field class="mb-0 mt-0" v-model="fields.button.link" id="buttonLink" hide-details />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <label for="buttonRadius">Button radius</label>
                  <v-text-field
                    class="mb-0 mt-0"
                    type="number"
                    v-model.number="fields.button.radius"
                    id="buttonRadius"
                    hide-details
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label for="buttonBackground">Button background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields.button.background"
                  />
                  <v-text-field
                    id="buttonBackground"
                    class="mb-0 mt-0"
                    v-model="fields.button.background"
                    hide-details
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label for="buttonColor">Button text color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields.button.color"
                  />
                  <v-text-field id="buttonColor" class="mb-0 mt-0" v-model="fields.button.color" hide-details />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="d-flex justify-space-between align-center">
          <label class="label-input" style="margin: 0">Product Items</label>
          <v-btn small text color="primary" @click="handleAddItem">
            <v-icon size="16">mdi-plus</v-icon>
            <span>Add item</span>
          </v-btn>
        </div>
        <v-expansion-panels accordion>
          <v-expansion-panel v-for="(item, i) in fields.listItem" :key="i">
            <v-expansion-panel-header>
              <div class="d-flex justify-space-between align-center">
                <label>Item {{ i + 1 }}</label>
                <v-btn icon @click.stop="handleRemoveItem(i)">
                  <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <UploadImage
                :image="{ imageSrc: item.image }"
                :height="`300`"
                :typeUpload="'image'"
                @callback="obj => handleUploadImage(obj, i)"
                @callbackDelete="handleRemoveUploadImage(i)"
              />

              <v-row class="mt-2">
                <v-col cols="12" md="12">
                  <div>
                    <label for="link">Link</label>
                    <v-text-field class="mb-0 mt-0" v-model="item.link" id="link" hide-details />
                  </div>
                </v-col>
                <v-col cols="12" md="12">
                  <div>
                    <label for="productName">Product name</label>
                    <v-text-field class="mb-0 mt-0" v-model="item.productName" id="productName" hide-details />
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div>
                    <label for="fromText">From text</label>
                    <v-text-field class="mb-0 mt-0" v-model="item.fromText" id="fromText" hide-details />
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div>
                    <label for="priceNew">Price new</label>
                    <v-text-field class="mb-0 mt-0" v-model="item.priceNew" id="priceNew" hide-details />
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div>
                    <label for="priceOld">Price old</label>
                    <v-text-field class="mb-0 mt-0" v-model="item.priceOld" id="priceOld" hide-details />
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div>
                    <div></div>
                    <v-checkbox
                      class="mb-0 mt-0"
                      v-model="item.showDiscount"
                      id="showDiscount"
                      hide-details
                      label="Show discount"
                    />
                  </div>
                </v-col>
                <v-col cols="12">
                  <div>
                    <label for="discountText">Discount text</label>
                    <v-text-field class="mb-0 mt-0" v-model="item.discountText" id="discountText" hide-details />
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

export default {
  name: 'SliderItemFyroroSectionEditor',
  components: { UploadImage },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Slider Item Fyroro Section',
        titleCard: '',
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
        },
        slider: {
          slidesPerView: 3,
          showPrice: true,
          showDiscountTag: true,
          discountBg: '#6293c1',
          discountColor: '#ffffff',
        },
        button: {
          show: true,
          text: 'View All',
          link: 'javascript:void(0)',
          background: '#000000',
          color: '#ffffff',
          radius: '0',
        },
        listItem: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleUploadImage(obj, i) {
      this.fields.listItem[i].image = obj.imageSrc;
    },
    handleRemoveUploadImage(i) {
      this.fields.listItem[i].image = '';
    },
    handleAddItem() {
      this.fields.listItem.push({
        image: '',
        showDiscount: true,
        discountText: 'Save 20%',
        productName: '',
        fromText: 'From',
        priceNew: '$9.99',
        priceOld: '$120.99',
      });
    },
    handleRemoveItem(i) {
      this.fields.listItem.splice(i, 1);
      if (!this.fields.listItem.length) {
        this.handleAddItem();
      }
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSliderItemFyroro(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 2px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.v-expansion-panels {
  border: 1px solid #c1c1c1;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.group-input {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #c1c1c1;
}
</style>
